import { render, staticRenderFns } from "./IncidentForm.vue?vue&type=template&id=3fc8aa8c&scoped=true"
import script from "./IncidentForm.vue?vue&type=script&lang=js"
export * from "./IncidentForm.vue?vue&type=script&lang=js"
import style0 from "./IncidentForm.vue?vue&type=style&index=0&id=3fc8aa8c&prod&scoped=true&lang=css"
import style1 from "./IncidentForm.vue?vue&type=style&index=1&id=3fc8aa8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc8aa8c",
  null
  
)

export default component.exports